module.exports = __webpack_public_path__ + "img/emo_07.96664d71.gif";